import { PAYMENTS_DD_RECEIPT_PATH, PAYMENTS_RECEIPT_PATH } from '@shared/constants/paths';

export const PAYMENT_BILL_TYPE = { MANUAL: 'MANUAL', MANUAL_USER: 'MANUAL-USER' };
export const PAYMENT_SUCCESS_CODE = '00000';

export const BILL_PAYMENT = 'BillPayment';
export const HHPAY = 'HHPAY';
export const TARGET_BLANK = '_blank';
export const NO_OPENER_NO_REFERRER = 'noreferrer, noopener';

export const CREDIT_CARD = 'credit-card';
export const DIRECT_DEBIT = 'direct-debit';
export const AMEX = 'amex';
export const UNKNOWN = 'Unknown';
export const REDIRECT_URL = 'redirect_url';

export const PAYMENT_CUTOFFTIME = {
  amex: {
    end: '22:05:00',
    start: '21:55:00',
  },
  creditCards: {
    end: '22:05:00',
    start: '21:55:00',
  },
  directDebit: {
    end: '23:35:00',
    start: '23:25:00',
  },
};

export const PAYMENT_CC_NOT_AVAILABLE = 'DT.Payment.Summary.Credit.NotAvailable';
export const PAYMENT_DD_NOT_AVAILABLE = 'DT.Payment.Summary.Debit.NotAvailable';

// DocText
export const ENETS_DEFAULT_ERROR_TEXT = 'receipt.enetsDefaultError';
export const PAYMENT_RECEIPT_ACKNOWLEDGEMENT = 'DT.Payment.Receipt.Acknowledgement';
export const PAYMENT_RECEIPT_ACKNOWLEDGEMENT_UNKNOWN = 'DT.Payment.Receipt.Acknowledgement.Unknown';
export const PAYMENT_RECEIPT_ACKNOWLEDGEMENT_UNSUCCESS = 'DT.Payment.Receipt.Acknowledgement.Unsuccess';
// ENETS
export const ENETS_TOKENISATION_ERROR_LIST = 'ENETS.Tokenisation.ErrorList';
export const ENETS_ERROR_LIST = 'ENETS.ErrorList';

export const TRUE = 'TRUE';

export const CLUSTER_CODE = {
  nationalHealthcareGroup: 'NHG',
  nationalUniversityHealthSystem: 'NUHS',
  singHealth: 'SHS',
};

export const PG = 'PG';
export const PG_ERROR_LEN = 6;
export const COMMON_PAYMENT_RECEIPT_PAGES: string[] = [PAYMENTS_RECEIPT_PATH, PAYMENTS_DD_RECEIPT_PATH];
export const RECEIPT_MODE1 = 'mode=1';

export const URL_AMPERSAND = '&';
export const URL_QUESTION_MARK = '?';
